import { FaDatabase } from 'react-icons/fa';
import { useLanguage } from '../../../../../_CORE/Contexts/Translate/useLanguageContext';
import { EmptyState } from '../Kit/_index';
import { ScreenState } from './ScreenState';

const BLOCK = 'LStudio__app_screen';

/*
    🔥 AVISO DE DATOS

    Cubre el hueco entre "cargando" y "hay datos", que en la práctica
    son tres situaciones distintas y casi siempre se resuelven como
    una sola:

      empty   -> el servidor respondió bien, pero no hay registros.
                 No es un error: mostrar una alarma roja acá asusta al
                 usuario por una lista vacía legítima.

      notice  -> el servidor respondió y algo no cerró (sin permiso
                 sobre el recurso, filtro inválido, dato incompleto).

      offline -> no hubo respuesta.

    ⚠️ ESTE COMPONENTE REFLEJA APP_DATA_FALLBACK_STRATEGY

    En AppLoadDataMode ya tenés declarado NOTICE | EMPTY | SEED. El
    contrato es el mismo a propósito: la vista le pasa la estrategia y
    esto decide qué cara poner, sin repetir el if en cada pantalla.

    Se deja como PROP y no se importa la config adentro para que la
    carpeta Templates siga siendo copiable a otro proyecto tal cual.
*/

const STRATEGY_MAP = {
    EMPTY: { icon: <FaDatabase />, tone: 'neutral', titleKey: 'emptyTitle', textKey: 'emptyText' },
    NOTICE: { icon: <FaDatabase />, tone: 'warn', titleKey: 'noticeTitle', textKey: 'noticeText' },
    OFFLINE: { icon: <FaDatabase />, tone: 'danger', titleKey: 'offlineTitle', textKey: 'offlineText' },
};

export const DataNotice = ({
    strategy = 'NOTICE',         // EMPTY | NOTICE | OFFLINE
    title = null,
    description = null,
    icon = null,
    action = null,
    onRetry = null,
    size = 'md',
    isCompact = false,           // true -> usa el EmptyState del Kit (para dentro de una tabla)
}) => {

    const { useDataLanguage } = useLanguage();

    const SCREEN = useDataLanguage.translations?.TEMPLATES?.screen ?? {};
    const COMMON = useDataLanguage.translations?.TEMPLATES?.common ?? {};

    const CONFIG = STRATEGY_MAP[strategy] ?? STRATEGY_MAP.NOTICE;

    const TITLE = title ?? SCREEN[CONFIG.titleKey];

    const TEXT = description ?? SCREEN[CONFIG.textKey];

    /*
        🔥 Dentro de una tabla o una tarjeta, la pantalla completa no
           entra: ahí conviene el EmptyState del Kit, que ya está
           pensado para vivir en un hueco chico.
    */
    if (isCompact) {
        return (
            <EmptyState
                icon={icon ?? CONFIG.icon}
                title={TITLE}
                description={TEXT}
                action={action}
                size={size}
            />
        );
    }

    return (
        <ScreenState
            icon={icon ?? CONFIG.icon}
            tone={CONFIG.tone}
            size={size}
            title={TITLE}
            description={TEXT}
            actions={
                action ?? (
                    typeof onRetry === 'function' && (
                        <button type="button" className={`${BLOCK}__button`} onClick={onRetry}>
                            {COMMON.retry}
                        </button>
                    )
                )
            }
        />
    );
};
